export default () => {
  return {
    restrict: 'A',
    link: function ($scope, $element, $attributes) {
      $element.on('keydown keyup', function(e) {
        let isMax = Number($element.val()) > Number($attributes.max);
        let isMin = Number($element.val()) < Number($attributes.min);

        console.log(isMin, isMax, $element.val());

        if (isMax || isMin && e.keyCode != 46 && e.keyCode != 8) {
          e.preventDefault();
          $element.val(isMax ? $attributes.max : $attributes.min);
        }
      });
    }
  };
};



// WEBPACK FOOTER //
// ./client/app/components/tree-diagram/number-min-max.directive.js